import { createContext, useContext, ReactNode } from 'react'
import { useAuth, AuthState, AuthActions } from '../hooks/useAuth'

// Create the context
const AuthContext = createContext<(AuthState & AuthActions) | undefined>(undefined)

// Provider component
interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const auth = useAuth()

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  )
}

// Hook to use the auth context
export function useAuthContext() {
  const context = useContext(AuthContext)
  
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider')
  }
  
  return context
}

// Export the context for advanced use cases
export { AuthContext }